import { wrap } from 'girder/utilities/PluginUtils';
import { restRequest } from 'girder/rest';
import events from 'girder/events';
import ItemView from 'girder/views/body/ItemView';

import '../stylesheets/views/itemList.styl';

wrap(ItemView, 'render', function (render) {
    function quarantine(event) {
        const item = this.model;
        restRequest({
            type: 'PUT',
            url: 'HistomicsTK/quarantine/' + item.id,
            error: null
        }).done((resp) => {
            events.trigger('g:alert', {
                icon: 'ok',
                text: 'Item quarantined.',
                type: 'success',
                timeout: 4000
            });
            this.render();
        }).fail((resp) => {
            events.trigger('g:alert', {
                icon: 'cancel',
                text: 'Failed to quarantine item.',
                type: 'danger',
                timeout: 4000
            });
        });
    }

    function appendWSILink(settings, $el, model) {
        if (!settings || !settings['histomicstk.webroot_path']) {
            return;
        }
        if ($el.find('.g-item-actions-menu').length && !$el.find('.g-histomicstk-open-item[role="menuitem"]').length &&
            model.attributes.largeImage) {
            var webroot_path = settings['histomicstk.webroot_path'];
            var itemLink = '/' + webroot_path + '#?image=' + model.id;
            $el.find('.g-item-actions-menu').prepend(
                `<li role="presentation">
                <a class="g-histomicstk-open-item" role="menuitem" href="${itemLink}" target="_blank">
                    <i class="icon-link-ext"></i>Open image in  WSI Viewer
                </a>
            </li>`
            );
        }
    }

    this.once('g:rendered', function () {
        if (this.$el.find('.g-edit-item[role="menuitem"]').length && !this.$el.find('.g-histomicstk-quarantine-item[role="menuitem"]').length) {
            this.$el.find('.g-edit-item[role="menuitem"]').parent('li').after(
                '<li role="presentation"><a class="g-histomicstk-quarantine-item" role="menuitem"><span>Q</span>Quarantine item</a></li>'
            );
        }
        if (!this._htk_settings) {
            restRequest({
                type: 'GET',
                url: 'HistomicsTK/settings'
            }).done((resp) => {
                this._htk_settings = resp;
                appendWSILink(this._htk_settings, this.$el, this.model);
            });
        } else {
            appendWSILink(this._htk_settings, this.$el, this.model);
        }
        this.events['click .g-histomicstk-quarantine-item'] = quarantine;
        this.delegateEvents();
    });
    render.call(this);
});



// WEBPACK FOOTER //
// ./plugins/HistomicsTK/web_client/views/itemPage.js